import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text_style" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text_style" }, " Por favor, desmarque algumas comissões para prosseguir com o envio. ", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'SnackbarLimitInvoice',
  props: {
    maxRows: { default: 80 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    color: "red-accent-2",
    style: {"height":"96%"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, " Você está tentando enviar um número de comissões que ultrapassa o limite de " + _toDisplayString(__props.maxRows) + " linhas de comissão por Nota Fiscal Eletrônica (NFE). ", 1),
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})